import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArrowheadRight = (props: SvgIconT.Props) => <SvgIcon {...props} viewBox="0 0 20 20" paths={['M7 15V5l5 5z']} />;

export default ArrowheadRight;
